import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { registerSessionExpiryUI } from "../../utils/sessionExpiryUI.js";

function isPublicSourcingPath(path = "") {
  const p = String(path || "");
  if (p.startsWith("/sourcing")) return true;
  if (p.startsWith("/invoice-finance")) return true;
  if (p.startsWith("/mortgages/invoice-finance")) return true;
  if (p.startsWith("/mortgages/buy-to-let")) return true;
  return false;
}

export default function SessionExpiredModal() {
  const [open, setOpen] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("/signin");

  useEffect(() => {
    registerSessionExpiryUI((payload) => {
      const path = typeof window !== "undefined" ? window.location.pathname || "" : "";
      // Public sourcing does not use a login session — never show this modal there
      if (isPublicSourcingPath(path)) return;
      setRedirectUrl(payload?.redirectUrl || "/signin");
      setOpen(true);
    });
    return () => registerSessionExpiryUI(null);
  }, []);

  useEffect(() => {
    if (!open) return;
    const path = typeof window !== "undefined" ? window.location.pathname || "" : "";
    if (isPublicSourcingPath(path)) setOpen(false);
  }, [open]);

  if (!open) return null;

  const goSignIn = () => {
    window.location.href = redirectUrl;
  };

  return createPortal(
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 p-4">
      <div
        className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 shadow-xl"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="session-expired-title"
      >
        <h3 id="session-expired-title" className="text-lg font-semibold text-slate-900">
          Session expired
        </h3>
        <p className="mt-2 text-sm text-slate-600">
          Your session has expired for security reasons. Please sign in again to continue.
        </p>
        <div className="mt-5 flex justify-end">
          <button
            type="button"
            onClick={goSignIn}
            className="rounded-lg bg-sky-600 px-4 py-2 text-sm font-semibold text-white hover:bg-sky-700"
          >
            Sign in again
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
